import { FirmInfoType } from '@/components/settings-page/platformSettings/firmInfo';
import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { getCacheBustedFileUrl } from '@/components/settings-page/utils';
import { IDocumentRecordTemplate } from '@/shared/types/templates/documentRecordTemplate';
import { isValidUrl } from '@/shared/utils/url';
import { Document, Page, Image as PdfImage, Text, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';
import { PDFTemplateFooter } from './components/PDFTemplateFooter';
import { PDFTemplateHeader } from './components/PDFTemplateHeader';
import { OneColumnSection } from './components/sections/OneColumnSection';
import { templateStyles } from './style';

interface DocumentRecordPDFTemplateProps {
  templateData: IDocumentRecordTemplate[];
  firmInfoData: FirmInfoType;
  templateStylingData: ITemplateStylingSettings;
  includeAiSuggested: boolean;
  theme: DefaultTheme;
}

export const DocumentRecordPDFTemplate = ({
  templateData,
  firmInfoData,
  templateStylingData,
  includeAiSuggested,
  theme
}: DocumentRecordPDFTemplateProps) => {
  return (
    <Document>
      <Page size="A4" style={templateStyles.page}>
        <PDFTemplateHeader templateStylingData={templateStylingData} theme={theme} />
        {templateStylingData?.watermark !== 'None' && isValidUrl(templateStylingData?.watermark) ? (
          <View style={templateStyles.watermarkWrap} fixed>
            <PdfImage style={templateStyles.watermark} src={getCacheBustedFileUrl(templateStylingData?.watermark)} />
          </View>
        ) : null}
        {templateStylingData?.watermark !== 'None' && !isValidUrl(templateStylingData?.watermark) ? (
          <View
            style={{
              position: 'absolute',
              bottom: templateStylingData?.watermark?.length > 15 ? '250px' : '400px',
              left: '50px',
              opacity: 0.1
            }}
            fixed
          >
            <Text style={templateStyles.watermarkText}>{templateStylingData?.watermark}</Text>
          </View>
        ) : null}
        {templateData.map((item, index) => (
          <View key={index} style={templateStyles.contentWrap} break={index !== 0}>
            <View style={templateStyles.header}>
              <View style={templateStyles.titleWrap}>
                <View
                  style={{
                    ...templateStyles.investmentName,
                    fontFamily: templateStylingData?.headerFontStyle?.fontFamily || 'Roboto Slab',
                    color: templateStylingData?.headerFontStyle?.fontColor
                      ? `#${templateStylingData?.headerFontStyle?.fontColor}`
                      : theme.font.strong,
                    width: '100%'
                  }}
                >
                  <Text>{item?.investmentName}</Text>
                </View>
              </View>
              {item?.updateName ? <Text style={{ ...templateStyles.templateName, color: theme.font.base }}>{item.updateName}</Text> : null}
              {item?.investmentDescription ? (
                <Text style={{ ...templateStyles.investmentDescription, color: theme.font.base }}>{item.investmentDescription}</Text>
              ) : null}
            </View>
            <OneColumnSection
              fields={item?.fields || []}
              templateStylingData={templateStylingData}
              includeAiSuggested={includeAiSuggested}
              theme={theme}
            />
          </View>
        ))}
        <PDFTemplateFooter firmInfoData={firmInfoData} theme={theme} />
      </Page>
    </Document>
  );
};
